<template>
    <div>
        <filtro-cadu
            v-model="valueData"
            @limparFiltro="clean"
            @filtrar="filtrar"
            @input="value => $emit('input', value)"
        >
            <div slot="body" class="mx-5" style="height: 420px">
                <v-row>
                    <v-col cols="auto">
                        <div class="fontColor1--text font-weight-bold">
                            FILTRAR HISTÓRICO
                        </div>
                    </v-col>
                </v-row>
                <ValidationObserver ref="observer" v-slot="{ slot: passes }">
                    <v-row>
                        <v-col cols="12">
                            <validation-provider mode="eager" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="itemsAbas.map((el) => el.nome)"
                                    @index="indexAbas"
                                    :errorMessage="errors[0]"
                                    title="Aba Atualizada"
                                    v-model="abaAtualizada.nome"
                                />
                            </validation-provider>
                        </v-col>
                        <v-col cols="auto">
                            <div class="fontColor1--text font-weight-bold">
                                ANEXO
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <validation-provider mode="eager" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="itemsAnexo.map((el) => el.nome)"
                                    @index="getIdAnexo"
                                    :errorMessage="errors[0]"
                                    title="Tipo de Anexo"
                                    v-model="tipoAnexo.nome"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="auto">
                            <div class="fontColor1--text font-weight-bold">
                                PERÍODO (mês e ano)
                            </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                          <datepicker-cadu
                            :menuOpen="menuOpen"
                            :inputTitle="'Data Inicial'"
                            :inputValue="dataInicial"
                            :showSelectedDate="dataInicialFormatada"
                            :disabled="false"
                            :validateProviderRules="'yearAndMonthValidator'"
                            :maxDate="maxDate"
                            @value="value => dataInicial = value"
                            width="280"
                          ></datepicker-cadu>
                        </v-col>
                        <v-col cols="12" md="6">
                          <datepicker-cadu
                            :menuOpen="menuOpen"
                            :inputTitle="'Data Final'"
                            :inputValue="dataFinal"
                            :showSelectedDate="dataFinalFormatada"
                            :disabled="false"
                            :validateProviderRules="regrasDataFinal"
                            :minDate="minDate"
                            :maxDate="maxDate"
                            @value="value => dataFinal = value"
                            width="280"
                          ></datepicker-cadu>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </div>
        </filtro-cadu>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import TipoDocumento from '@/services/Dominios/TipoDocumento'
import VersaoHistorico from '@/services/Historico/VersaoHistorico'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean
    }
  },
  data () {
    return {
      abaAtualizada: {
        nome: '',
        valor: ''
      },
      tipoAnexo: {
        nome: '',
        id: ''
      },
      dataInicial: '',
      dataFinal: '',
      itemsAbas: ['Dados Cadastrais'],
      itemsAnexo: [],
      valueData: this.value,
      tokenBearer: localStorage.getItem('tokenBearer'),
      dataInicialFormatada: '',
      dataFinalFormatada: '',
      menuOpen: false
    }
  },
  beforeMount () {
    this.loadingDominios()
  },
  methods: {
    indexAbas (index) {
      this.abaAtualizada.valor = (index > -1 && index != null) ? this.itemsAbas[index].valor : ''
    },
    getIdAnexo (index) {
      this.tipoAnexo.id = (index > -1 && index != null) ? this.itemsAnexo[index].id : ''
    },
    async loadingDominios () {
      await this.loadingAbas()
      await this.loadingAnexos()
    },
    async loadingAbas () {
      let abasAtualizadas = new VersaoHistorico(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseGet = await abasAtualizadas.getAbas()
        this.itemsAbas = responseGet.data
      } catch (err) {
        console.error(err)
      }
    },
    async loadingAnexos () {
      let tipoDocumento = new TipoDocumento(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseGet = await tipoDocumento.getTipoDocumento()
        this.itemsAnexo = responseGet.data
      } catch (err) {
        console.error(err)
      }
    },
    async filtrar () {
      if (await this.$refs.observer.validate()) {
        this.$emit('filtrar', {
          abaAtualizada: this.abaAtualizada.valor,
          idAnexo: this.tipoAnexo.id,
          dataInicial: this.dataInicial,
          dataFinal: this.dataFinal
        })
      }
    },
    clean () {
      this.abaAtualizada = {
        nome: '',
        valor: ''
      }
      this.tipoAnexo = {
        nome: '',
        id: ''
      }
      this.dataInicial = ''
      this.dataFinal = ''
    }
  },
  computed: {
    regrasDataFinal () {
      if (this.dataInicial) {
        return `yearAndMonthValidator|validateDataFinal: ${this.dataInicial} `
      } else {
        return 'yearAndMonthValidator'
      }
    },
    minDate () {
      if (this.dataInicial) {
        return `01/${this.dataInicial}`
      } else {
        return ''
      }
    },
    maxDate () {
      let dateNow = new Date()
      return `${dateNow.getDay()}/${dateNow.getMonth() + 1}/${dateNow.getFullYear()}`
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    }
  }
}
</script>

<style>

</style>
